module.exports = "<a href=\"https://www.froland.kommune.no/\">\n  <img src=\"assets/froland.png\" />\n</a>\n"